"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Text = _interopRequireDefault(require("../Input/Text"));

require("./InputListItem.less");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var InputListItem = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(InputListItem, _Component);

  var _super = _createSuper(InputListItem);

  function InputListItem(props) {
    var _this;

    (0, _classCallCheck2.default)(this, InputListItem);
    _this = _super.call(this, props);
    _this.state = {
      value: _this.props.value || ''
    };
    _this.handleAdd = _this.handleAdd.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRemove = _this.handleRemove.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(InputListItem, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.props.value) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: "handleAdd",
    value: function handleAdd() {
      this.props.onAdd();
    }
  }, {
    key: "handleRemove",
    value: function handleRemove() {
      this.props.onRemove();
    }
  }, {
    key: "handleChange",
    value: function handleChange(value) {
      this.setState({
        value: value
      }, this.props.onChange(this.props.index, value));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          placeholder = _this$props.placeholder,
          size = _this$props.size,
          icon = _this$props.icon,
          itemMinLength = _this$props.itemMinLength,
          itemMaxLength = _this$props.itemMaxLength;
      var value = this.state.value;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "primitive-input-list-item-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_Text.default, {
        value: value,
        placeholder: placeholder,
        onChange: function onChange(value) {
          _this2.handleChange(value);
        },
        size: size,
        minLength: itemMinLength,
        maxLength: itemMaxLength
      }), icon);
    }
  }], [{
    key: "propTypes",
    value: function propTypes() {
      return {
        value: _propTypes.default.string,
        placeholder: _propTypes.default.string,
        onChange: _propTypes.default.func,
        size: _propTypes.default.oneOf(['smallest', 'small', '', 'large']),
        itemMinLength: _propTypes.default.string,
        itemMaxLength: _propTypes.default.string,
        onAdd: _propTypes.default.func,
        onRemove: _propTypes.default.func,
        icon: _propTypes.default.element
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        value: '',
        placeholder: '',
        onChange: function onChange() {},
        size: '',
        itemMinLength: '',
        itemMaxLength: '',
        onAdd: function onAdd() {},
        onRemove: function onRemove() {},
        icon: null
      };
    }
  }]);
  return InputListItem;
}(_react.Component);

exports.default = InputListItem;